import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormazioniComponent } from './formazioni.component';

@NgModule({
    imports: [CommonModule],
    declarations: [FormazioniComponent],
    exports: [FormazioniComponent],
    providers: []
})
export class FormazioniModule { }


// WEBPACK FOOTER //
// ./src/app/formazioni/formazioni.module.ts